/**
 * @generated SignedSource<<68535bce111e2bd36cfc686d827ced0d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type job_useMissingSubtypesUser$data = {
  readonly profile: {
    readonly specializations: ReadonlyArray<{
      readonly id: string;
    }> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "job_useMissingSubtypesUser";
};
export type job_useMissingSubtypesUser$key = {
  readonly " $data"?: job_useMissingSubtypesUser$data;
  readonly " $fragmentSpreads": FragmentRefs<"job_useMissingSubtypesUser">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "job_useMissingSubtypesUser",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "kind": "LinkedField",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Specialization",
          "kind": "LinkedField",
          "name": "specializations",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "6b02e6e910cb374e68be64f097a98a1b";

export default node;
